import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { find } from "lodash";
import * as moment from 'moment';
import { environment } from '../../../../environments/environment';
import { StoreConfig } from '../../../shared/interface/StoreConfig.interface';
import { CommonService } from '../../../shared/services/common.service';
import { Constants, MemberType } from '../../common/constants';
import { DeliveryPreference, MemberLevel, PurchaseFlow } from '../../common/enumerations';
import { StoreMetaDataConstants } from '../../constants/store-metadata.constants';
import { MemberTypeEnum } from '../../enums/member-type.enum';
import { AddressType, PaymentMethodTypes } from "../../enums/order-source-type";
import { PaymentCardTypes } from "../../enums/payment-card-types.enum";
import { AppCountryConfig } from '../../interface/app-config';
import { CheckoutConfig } from '../../interface/checkout-config.interface';
import { OrderConfig } from '../../interface/order-Config.interface';
import { TaxType } from "../../interface/tax-type.interface";
import { AppConfigService } from '../../services/app-config.service';
import { CheckoutConfigService } from '../../services/checkout-config.service';
import { OrderConfigService } from '../../services/order-config.service';
import { OrderLineItem } from "../../interface/enrollment";
import { OrderLineItemTypeEnum } from "../../../shared/enums/order-lineitem-type.enum";
import { PrintOptions } from '../../enums/print-option.enum';
import { IbanFormat } from '../../../common/pipes/iban-format.pipe';
import { CustomerService } from '../../services/customer.service';
import { PaymentMethodTypeConstants } from '../../constants/payment-method-types.constants';

@Component({
    selector: 'app-print-invoice',
    templateUrl: '../../templates/template1/views/reports/print-invoice.component.html',
    styleUrls: ['../../templates/template1/themes/default/less/print-invoice.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrintInvoiceComponent implements OnInit, AfterViewInit {
    @Input() countries: any;
    @Input() orderStoreInfo: any;
    @Input() storeMetaInfo: any;
    @Input() orderInvoiceList: any;
    @Input() quantity: number;
    @Input() printOption: string;
    errormessage = false;
    showDetail = false;
    showLineItem = false;
    isDmUser: boolean;
    isRetailOrder: boolean;
    enrolmentOrPersonalOrder: boolean;
    isDistributor: boolean;
    isPrefferedCustomer: boolean;
    isPickUp: boolean;
    paymentInfo: boolean;
    showPayment: boolean;
    shippingImageFlag: boolean;
    moComponentSettings: any;
    registerAddress: any;
    orderNumber: any;
    orderDate: any;
    orderType: any;
    lineItems: any;
    total: any;
    currencyType: any;
    currencySymbols: any;
    currencySymbol: any;
    shippingMethod: any;
    shippingAddressInfo: any;
    memberAddressDetails: any;
    participatingCountries: any[];
    paymentDetails: any;
    expDate: any;
    totalQty: number;
    totalDiscountAmount: number;
    totalSavings: number;
    totalUnitPrice: number;
    totalTaxableAmount: number;
    totalExtendedPrice: number;
    gstTax: number;
    pstTax: number;
    distributorName: string;
    memberLevel = '';
    empty = '';
    priceTierName: string;
    fboId: string;
    webOrderId: string;
    globalOrderNumber:any
    itemSubTotal: string;
    shipping: string;
    corporateVatId: string;
    enableVatinInvoice: string;
    vatNumber: string;
    tax: string;
    totalcc: string;
    emailId: string;
    shipFrom: string;
    registerAddressphoneNumberFormat: string;
    shippingImage: string;
    shippingCountry: string;
    phoneNumberFormat: string;
    paymentMethod: string;
    paymentCardType: string;
    paymentCardNo: string;
    shippingImageUrl: string;
    orderDetailsConfig: OrderConfig;
    myAccountConfig: CheckoutConfig;
    store: StoreConfig;
    appCountryConfig: AppCountryConfig;
    orderInformation = [];
    vatBreakdownStores=['GBR', 'IRL', 'ILN'];
    vatBreakdownCountry: boolean;
    donationItemExist: OrderLineItem;
    organizationNumber: string;
    placeOfIncorporation: string;
    taxCertificateNote: string;
    orderInfoObj: any = {}
    storeTimeZoneOffSet:any;
    printOptions = PrintOptions;
    taxType=TaxType;
    hasOrderLevelDiscount: boolean = false
    hasBondedProduct: boolean = false;
    hasNonBondedProduct: boolean = false;
    totalRetailPrice:number;
    totalDiscount:number;
    isSingleOrDirect: boolean;
    obfuscatedIban: string;
    creditorID: any;
    displaySystemOrderNumber: boolean;    
    isIntegratedTerminalAdyenPymt :boolean;
    isInvoice: boolean = false;
    removeCommaOnInvoive :boolean |any;
    constructor(
        private _appConfigService: AppConfigService,
        private _checkoutConfigService: CheckoutConfigService,
        private _commonService: CommonService,
        private _orderConfig: OrderConfigService,
        private _cdr: ChangeDetectorRef,
        private _ibanFormatPipe: IbanFormat,
        private _customerservice: CustomerService
    ) { }

    ngOnInit() {
        if(this.printOption == 'Invoice'){
            this.isInvoice = true;
        }else{
            this.isInvoice = false;
        }
        for (let i = 0; i < this.orderInvoiceList.length; i++) {
            this.getStoresInfo();
            this.orderInfoObj = {};
            this.getVatandMemberTitle(i);
            this.getCountryConfig(this.orderInvoiceList[i].orderDetails, this.orderInvoiceList[i].distributorInfo, i);
            this.getOrderDetails(this.orderInvoiceList[i].orderDetails, this.orderInvoiceList[i].distributorInfo, i);
            if (this.orderInvoiceList[i].distributorInfo && this.orderInvoiceList[i].distributorInfo.memberTypeId
                && (this.orderInvoiceList[i].distributorInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR)) {
                this.isDistributor = true;
            }
            if (this.orderInvoiceList[i].distributorInfo && this.orderInvoiceList[i].distributorInfo.memberTypeId && (this.orderInvoiceList[i].distributorInfo.memberTypeId === MemberTypeEnum.FPC)) {
                this.isPrefferedCustomer = true;
            }
            this.getStoreMetaData(this.storeMetaInfo);
            this.getMemberDetailById(this.orderInvoiceList[i].memberAddressInfo);
            this.orderInfoObj.distributorInfo = this.orderInvoiceList[i].distributorInfo;
            this.orderInfoObj.distributorInfo.displayMiddleName = this.orderStoreInfo ? this.orderStoreInfo.displayMiddleName : false;
            this.orderInfoObj.isDistributor = this.isDistributor;
            this.orderInfoObj.isPrefferedCustomer = this.isPrefferedCustomer;
            this.orderInfoObj.orderDetails = this.orderInvoiceList[i].orderDetails;
            this.orderInfoObj.displaySystemOrderNumber = this.myAccountConfig && this.myAccountConfig.displaySystemOrderNumber && this.orderInfoObj.orderDetails && this.orderInfoObj.orderDetails.source === 'POS' ? true : false;
            if(this.orderDetailsConfig.displayVatTaxLineItem || this.vatBreakdownCountry){
                let orderLineItems=[];
                this.orderInvoiceList[i].orderDetails.orderLineItems.forEach(lineItem=>{
                    if(lineItem.orderLineNumber){
                         orderLineItems.push(lineItem);                   
                     }
                 })
                this.orderInfoObj.lineItems = orderLineItems;
            }   
            for(let j=0; j < this.quantity; j++) {
                this.orderInformation.push(this.orderInfoObj);
            }
            window.scrollTo(0, 0);
        }
    if (this.orderStoreInfo){
        this.orderStoreInfo.ccNumberDecimals = 3;
        this.orderStoreInfo.ccNumberFormat = 'CR';
        this.orderStoreInfo.ccSymbol = 'CC';
    }
    }

    ngAfterViewInit() {
        this._cdr.detectChanges();
    }


    /**
     * Get Vat registered and member title
     * @param i
     */
    private getVatandMemberTitle(i: number) {
        if (this.orderInvoiceList[i].distributorInfo) {

            if (+this.orderInvoiceList[i].distributorInfo.memberTypeId !== MemberTypeEnum.DISTRIBUTOR) {
                this.orderInvoiceList[i].distributorInfo.vatRegistered = false;
            }
            const countryObj = this.countries.find((x: any) => x.isocodeThree.toLowerCase() === this.orderInvoiceList[i].orderDetails.countryCode.toLowerCase());
            if (countryObj) {
                this.orderInvoiceList[i].distributorInfo.vatRegistered = this._commonService.getVatDetail(countryObj, this.orderInvoiceList[i].distributorInfo);
            }
            if (+this.orderInvoiceList[i].distributorInfo.memberTypeId === MemberTypeEnum.GUEST) {
                this.orderInvoiceList[i].distributorInfo.memberTitle = MemberType.GUEST;
            } else if (+this.orderInvoiceList[i].distributorInfo.memberTypeId === MemberTypeEnum.FPC) {
                this.orderInvoiceList[i].distributorInfo.memberTitle = MemberType.PREFERREDCUSTOMER;
            }
            if (this.orderInvoiceList[i].distributorInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR
                && this.orderInvoiceList[i].distributorInfo.memberTitleId === MemberLevel.NOVICCUSTOMER) {
                this.orderInvoiceList[i].distributorInfo.memberTitle = MemberType.PREFERREDCUSTOMER;
            }
        }
    }

    /**
     * will get Country Based Configuration Values
     * @returns void
     * @memberof OrderDetailsComponent
     */
    getCountryConfig(orderDetails, distributorInfo, i): void {
        if (orderDetails) {
            this.appCountryConfig = this._appConfigService.getSettings(orderDetails.countryCode, distributorInfo);
        }
    }
 
    /**
  * getOrderDetails Method used to get the order details
  * @param  {string} webOrderId
  * @returns void
  */
    getOrderDetails(orderdetails: any, distributorInfo, i): void {
        if (orderdetails) {
            if (!orderdetails.shipToName && orderdetails.firstName && orderdetails.lastName) {

                orderdetails.shipToName = orderdetails.firstName + ' ' + (orderdetails.middleName && orderdetails.displayMiddleName
                    ? orderdetails.middleName + ' ' : '') + orderdetails.lastName;
            }
            if (orderdetails.isDM) {
                this.isDmUser = orderdetails.isDM;
                this.totalDiscountAmount = orderdetails.totalDiscountAmount &&
                    orderdetails.totalDiscountAmount > 0 ? orderdetails.totalDiscountAmount : null;
            }
            const countrycode = orderdetails.countryCode;
            if(environment.removeCommaOnInvoice){
                this.removeCommaOnInvoive = environment.removeCommaOnInvoice.split(',').includes(countrycode);
                }
            // this.getStoreInfo(countrycode);
            this.myAccountConfig = this._checkoutConfigService.getSettings(countrycode, null);
            this.orderDetailsConfig = this._orderConfig.getSettings(countrycode, distributorInfo);
            this.vatBreakdownCountry = this.isVatBreakdownCountry(countrycode);
            this.orderInvoiceList[i].orderDetails = orderdetails;
            this.isRetailOrder = this.orderInvoiceList[i].orderDetails.orderTypeId === PurchaseFlow.Retail;
            if (this.orderInvoiceList[i].orderDetails && this.orderInvoiceList[i].orderDetails.orderTypeId
                && this.orderInvoiceList[i].orderDetails.orderTypeId === PurchaseFlow.Enrollment
                || this.orderInvoiceList[i].orderDetails.orderTypeId === PurchaseFlow.Personal_Order) {
                this.enrolmentOrPersonalOrder = true;
            }
            if(this.orderDetailsConfig.displayVatTaxLineItem || this.vatBreakdownCountry){
                let removeChildProduct = [];
                this.orderInvoiceList[i].orderDetails.orderLineItems.forEach(orderLineItem=>{
                    if(orderLineItem.orderLineNumber){
                        removeChildProduct.push(orderLineItem);
                    }
                })
                this.orderInvoiceList[i].orderDetails.orderLineItems = removeChildProduct;
            }
            this.totalRetailPrice = this.orderInvoiceList[i].orderDetails.orderLineItems.reduce((sum, y) => {
                if (!(y.lineItemTypeId === OrderLineItemTypeEnum.CHILD_PRODUCT)) {
                    return sum + (y.unitRetailPrice * y.quantity);
                }
                return sum;
            }, 0);
            this.totalDiscount = this.orderInvoiceList[i].orderDetails.orderLineItems.reduce((sum, y) => {
                if (!(y.lineItemTypeId === OrderLineItemTypeEnum.CHILD_PRODUCT)) {
                    return sum + ((y.unitRetailPrice - y.unitPaidPrice) * y.quantity)
                }
                return sum;
            }, 0);
            this.prepareOrderDetailsData(this.orderInvoiceList[i].orderDetails, distributorInfo, this.orderDetailsConfig, i);
            this.getOrderPaymentInfo(this.orderInvoiceList[i].orderDetails.billingInfo);
            this.emptyCheck();

            this.orderInfoObj.isDmUser = this.isDmUser;
            this.orderInfoObj.totalDiscountAmount = this.totalDiscountAmount;
            this.orderInfoObj.myAccountConfig = this.myAccountConfig;
            this.orderInfoObj.orderDetails = this.orderInvoiceList[i].orderDetails;
            this.orderInfoObj.isRetailOrder = this.isRetailOrder;
            this.orderInfoObj.enrolmentOrPersonalOrder = this.enrolmentOrPersonalOrder;
            this.orderInfoObj.totalRetailPrice = this.totalRetailPrice
            this.orderInfoObj.totalDiscount = this.totalDiscount;
        }
    }


    /**
     * @description  to prepare payment Detaiils
     * @author Akhil
     * @date 2020-11-27
     * @param {*} paymentResonse
     * @memberof PrintLayoutComponent
     */
    getOrderPaymentInfo(paymentResonse) {
        if (paymentResonse) {
            this.paymentInfo = true;
            this.paymentDetails = paymentResonse;
            if(this.appCountryConfig && this.appCountryConfig.displayStatementForWavePayment){
                if(this.paymentDetails.paymentMethod === PaymentMethodTypes.Money_order)
                    this.paymentDetails.paymentMethod = PaymentMethodTypeConstants.Wave;
                else if(this.paymentDetails.paymentMethod === PaymentMethodTypeConstants.Orange_Money)
                    this.paymentDetails.paymentMethod = PaymentMethodTypeConstants.Orange_Money;
            }          
            this.paymentMethod = this.paymentDetails.paymentMethod ? this.paymentDetails.paymentMethod : 'NA';                        
            this.isSingleOrDirect = this.paymentMethod && (this.paymentMethod === PaymentMethodTypes['Direct_Debit'] || this.paymentMethod === PaymentMethodTypes['Single_Debit'])
            if (this.isSingleOrDirect)
                this.obfuscatedIban = this._ibanFormatPipe.transform(this.paymentDetails.paymentAccountNumber);
                const paymentLabel = this.paymentMethod ?
                PaymentMethodTypes[this.paymentMethod] ? this._commonService.getPaymentTypeLabel(this.paymentMethod) : this.paymentMethod : 'NA';
               this.isIntegratedTerminalAdyenPymt= (paymentLabel ==PaymentMethodTypeConstants.Integrated_Terminal_Adyen ? true : false);
            this.paymentCardType = this.paymentDetails.cardType ? this.paymentDetails.cardType : 'NA';
            const cardLabel = this.paymentCardType ?
                PaymentCardTypes[this.paymentCardType] ? PaymentCardTypes[this.paymentCardType] : this.paymentCardType : 'NA';
            this.paymentCardNo = this.paymentDetails.maskedCard ? this.paymentDetails.maskedCard : 'NA';
            this.expDate = this.paymentDetails.expiryMonth ? (this.paymentDetails.expiryMonth +
                '/' + this.paymentDetails.expiryYear.substring(2, 4)) : 'NA';
            this.moComponentSettings = this.preparePaymentLables(paymentLabel, cardLabel);
        }
        this.orderInfoObj.paymentInfo = this.paymentInfo;
        this.orderInfoObj.paymentDetails = this.paymentDetails;
        this.orderInfoObj.paymentMethod = this.paymentMethod;
        this.orderInfoObj.paymentCardType = this.paymentCardType;
        this.orderInfoObj.paymentCardNo = this.paymentCardNo;
        this.orderInfoObj.obfuscatedIban = this.obfuscatedIban;
        this.orderInfoObj.expDate = this.expDate;
        this.orderInfoObj.moComponentSettings = this.moComponentSettings;
    }

    /**
         * @description prepare Payment Types ;
         * @author Akhil
         * @date 2020-11-27
         * @param {*} paymentLabel
         * @param {*} cardLabel
         * @returns {*}
         * @memberof PrintLayoutComponent
         */
    preparePaymentLables(paymentLabel: any, cardLabel: any): any {
        const paymentTypes = PaymentMethodTypes;
        const payementDetails: any = {
            paymentMethodTypes: paymentTypes,
            paymentMethodLabel: paymentLabel,
            cardTypeLabel: cardLabel
        }
        return payementDetails;
    }

    emptyCheck() {
        if (this.shippingAddressInfo && this.shippingAddressInfo.shipToName === this.empty
            && this.shippingAddressInfo.phone === this.empty && this.shippingAddressInfo.email === this.empty
            && this.shippingAddressInfo.addressLine1 === this.empty && this.shippingAddressInfo.addressLine1 === this.empty
            && this.shippingAddressInfo.city === this.empty
            && this.shippingCountry === this.empty && this.shippingAddressInfo.stateCode === this.empty) {
            this.showDetail = false;
        } else { this.showDetail = true; }
        if (this.paymentCardType === this.empty && this.expDate === this.empty && this.paymentCardNo === this.empty) {
            this.showPayment = true;
        } else { this.showPayment = false; }

        if (this.lineItems && this.lineItems.length === 0) {
            this.showLineItem = true;
        } else { this.showLineItem = false; }

        this.orderInfoObj.showDetail = this.showDetail;
        this.orderInfoObj.showPayment = this.showPayment;
        this.orderInfoObj.showLineItem = this.showLineItem;
    }

    /**
        * prepareOrderDetailsData Method used to set the order details data
        * @param  {any} orderDetails
        * @returns void
        */

    prepareOrderDetailsData(orderDetails: any, distributorInfo, orderDetailsConfig, i): void {
        let symbol: any;
        this.distributorName = distributorInfo.firstName + ' ' + distributorInfo.lastName;
        this.memberLevel = distributorInfo.memberTitle;
        const enableWHLSAL00ForAsstSupervisor = this._commonService.isWHLSAL00enabledForAsstSupervisor(orderDetails.countryCode);
        this.priceTierName = this._commonService.getDiscountPriceLevel(orderDetails.priceTierId,
            orderDetails.memberLevelDiscount, orderDetails.memberTypeId, enableWHLSAL00ForAsstSupervisor);
        this.fboId = orderDetails.distrubutorId;
        this.orderNumber = this.orderDetailsConfig.displayErpNumber? orderDetails.erpNumber : orderDetails.orderNumber;
        this.webOrderId = orderDetails.webOrderId;
        this.globalOrderNumber= orderDetails.globalOrderNumber? orderDetails.globalOrderNumber:null;
        this.orderDate = moment.utc(orderDetails.storePostedDate).format('DD-MMM-YYYY');
        orderDetails.orderLineItems.sort((a: any, b: any) => {
            return a.orderLineNumber - b.orderLineNumber;
        });
        this.lineItems = orderDetails.orderLineItems;
        this.hasOrderLevelDiscount = orderDetails.orderLevelDiscount ? true : false;
        if (this.orderDetailsConfig && this.orderDetailsConfig.isDEUCountry && orderDetails && orderDetails.taxMetaData && orderDetails.taxMetaData.orderTaxCharges) {
            const items = orderDetails.taxMetaData.orderTaxCharges;
            items.forEach((element, index) => {
                if (element.lineNo === 0) {
                    if(this.hasOrderLevelDiscount){
                        items[index].taxChargeBased = element.taxChargeBased - element.taxAmount;
                    }
                    this.orderInfoObj.shippingTaxRate = element.taxRate;
                }
            });
        }
        const hasNonBondedProduct = this.lineItems.find((x) => !x.bondedProduct)
        if (this.hasOrderLevelDiscount) {
            this.hasBondedProduct = true;
            orderDetails.taxMetaData.orderTaxCharges = orderDetails.taxMetaData.orderTaxCharges.filter(item => item.taxRate > 0 || this.orderDetailsConfig.displayTotalColumnOnTaxChargeTypeZero);
        }
        if (hasNonBondedProduct) {
            this.hasBondedProduct = false;
            this.hasNonBondedProduct = true;
        }
        this.donationItemExist = orderDetails.orderLineItems.find((x) => x.lineItemTypeId == OrderLineItemTypeEnum.DONATION_PRODUCT);
        this.itemSubTotal = orderDetails.orderSubTotal;
        this.totalQty = this.getTotalQuantity(orderDetails.orderLineItems);
        this.shipping = orderDetailsConfig.calculateShippingWithTax && orderDetails.shippingCost && orderDetails.shippingTax
            && (!orderDetails.vatRegistered || orderDetails.memberTypeId !== MemberTypeEnum.DISTRIBUTOR) ?
            orderDetails.shippingCost + orderDetails.shippingTax : orderDetails.shippingCost;
        orderDetails.shippingCost = orderDetailsConfig.calculateShippingWithTax && orderDetails.shippingCost
            && orderDetails.shippingTax && (!orderDetails.vatRegistered ||
                orderDetails.memberTypeId !== MemberTypeEnum.DISTRIBUTOR)
            ? orderDetails.shippingCost + orderDetails.shippingTax : orderDetails.shippingCost;
        orderDetails.shippingCost = orderDetails.shippingCost ? orderDetails.shippingCost : 0;
        this.tax = orderDetails.orderTax;
        this.total = (orderDetails.orderTotal === '' ? '0.0' : orderDetails.orderTotal);
        this.totalcc = orderDetails.orderTotalCC;
        this.emailId = orderDetails.email;
        //this.handling = this.orderDetails.handling;
        this.currencyType = orderDetails.currencyType;
        symbol = find(this.currencySymbols, { currencyCode: this.currencyType });
        this.currencySymbol = symbol ? symbol.currencySymbol : '$';
        if (orderDetails.orderShippings && orderDetails.orderShippings.length > 0) {
            if (orderDetails.orderShippings[0].deliveryPreferenceId === DeliveryPreference.PICKUP) {
                this.isPickUp = true;
            } else {
                this.getShipMethodInfo(orderDetails);
                if (orderDetailsConfig && !orderDetailsConfig.isDisplayShipping) {
                    orderDetailsConfig.handlingDisplay = true;
                }
            }
        }
        if (orderDetails.addresses && orderDetails.addresses.length > 0) {
            this.getMemberAddressByMemberId(orderDetails.addresses);            
           this.getParticipatingCountries(orderDetails.countryCode, orderDetails,distributorInfo);
            this.displayOrderVatTax(orderDetails);
            this.calculateTotals(orderDetails.orderLineItems, orderDetails.shippingCost,
                orderDetails.importFeeValue, orderDetails);
        }
        else {
            this.displayOrderVatTax(orderDetails);
            this.calculateTotals(orderDetails.orderLineItems, orderDetails.shippingCost,
                orderDetails.importFeeValue, orderDetails);
        }
        if (orderDetails && orderDetails.taxMetaData
            && orderDetails.taxMetaData.orderTaxCharges && orderDetails.taxMetaData.orderTaxCharges.length) {
            const gst = orderDetails.taxMetaData.orderTaxCharges.find(tax => tax.taxChargeType === TaxType.GST_TAX);
            const pst = orderDetails.taxMetaData.orderTaxCharges.find(tax => tax.taxChargeType === TaxType.PST_TAX);
            this.gstTax = gst ? gst.taxAmount : 0;
            this.pstTax = pst ? pst.taxAmount : 0;
        }
        //=> // PS2020-489 --> USA Tax issue
        if (orderDetails && (!orderDetails.orderTax || orderDetails.orderTax <= 0)
            && orderDetails.countryCode === 'USA' && orderDetails.taxMetaData
            && orderDetails.taxMetaData.orderTaxCharges
            && orderDetails.taxMetaData.orderTaxCharges.length > 0) {
            const slsTax = orderDetails.taxMetaData
                .orderTaxCharges.find(tax => tax.taxChargeType === TaxType.SLS_TAX);
            this.tax = slsTax ? slsTax.taxAmount : 0;

        }
        this.phoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(orderDetails.countryCode);
        this.orderInfoObj.distributorName = this.distributorName;
        this.orderInfoObj.memberLevel = this.memberLevel;
        this.orderInfoObj.priceTierName = this.priceTierName;
        this.orderInfoObj.fboId = this.fboId;
        this.orderInfoObj.orderNumber = this.orderNumber;
        this.orderInfoObj.webOrderId = this.webOrderId;
        this.orderInfoObj.globalOrderNumber =this.globalOrderNumber;
        this.orderInfoObj.orderDate = this.orderDate;
        this.orderInfoObj.lineItems = this.lineItems;
        this.orderInfoObj.itemSubTotal = this.itemSubTotal;
        this.orderInfoObj.totalQty = this.totalQty;
        this.orderInfoObj.shipping = this.shipping;
        this.orderInfoObj.tax = this.tax;
        this.orderInfoObj.total = this.total;
        this.orderInfoObj.totalcc = this.totalcc;
        this.orderInfoObj.emailId = this.emailId;
        this.orderInfoObj.isPickUp = this.isPickUp;
        this.orderInfoObj.gstTax = this.gstTax;
        this.orderInfoObj.pstTax = this.pstTax;
        this.orderInfoObj.tax = this.tax;
        this.orderInfoObj.phoneNumberFormat = this.phoneNumberFormat;
        this.orderInfoObj.orderDetailsConfig = this.orderDetailsConfig;
        this.orderInfoObj.hasOrderLevelDiscount = this.hasOrderLevelDiscount;
        this.orderInfoObj.hasNonBondedProduct = this.hasNonBondedProduct;
    }

    /**
    * get totals from orderline items
    * @returns number
    */
    calculateTotals(orderLineItems: any, shippingCost: number, importFeeValue: number, orderDetails: any) {
        let totalUnitPrice = 0;
        let totalTaxableAmount = 0;
        let totalExtendedPrice = 0;
        let totalRetailPrice = 0;
        let totalBwpExtendedPrice = 0;
        if (orderLineItems && orderLineItems.length) {
            orderLineItems.forEach(item => {
                totalUnitPrice = totalUnitPrice + item.unitPaidPrice;
                totalRetailPrice = totalRetailPrice + (item.unitRetailPrice * item.quantity);
                totalTaxableAmount = totalTaxableAmount + item.totalRetailPrice;
                totalExtendedPrice = totalExtendedPrice + item.totalAmount;
                if(item.bondedProduct)
                    totalBwpExtendedPrice = totalBwpExtendedPrice + item.totalAmount
            });
        }
        let wholesaleQualified: boolean;
        let optin: boolean;
        if (orderDetails) {
            wholesaleQualified = orderDetails.wholesaleQualified;
            optin = orderDetails.optin;
        }
        // const discountPerc = this._commonService.getDiscountPerc(memberTitleId, wholesaleQualified, optin);
        const discountPerc = orderDetails.memberLevelDiscount;
        this.totalSavings = discountPerc ? (totalRetailPrice * discountPerc) / 100 : 0;
        this.totalUnitPrice = totalUnitPrice + (shippingCost ? shippingCost : 0) + (importFeeValue ? importFeeValue : 0);
        this.totalTaxableAmount = totalTaxableAmount + (shippingCost ? shippingCost : 0) + (importFeeValue ? importFeeValue : 0);
        this.totalExtendedPrice = totalExtendedPrice + (shippingCost ? shippingCost : 0) + (importFeeValue ? importFeeValue : 0);
        this.orderInfoObj.totalSavings = this.totalSavings;
        this.orderInfoObj.totalUnitPrice = this.totalUnitPrice;
        this.orderInfoObj.totalTaxableAmount = this.totalTaxableAmount;
        this.orderInfoObj.totalExtendedPrice = this.totalExtendedPrice;
        if(totalBwpExtendedPrice) {
            this.totalDiscountAmount = orderDetails.orderLevelDiscount;
            this.orderInfoObj.bwpBaseChargeAmount = totalBwpExtendedPrice - this.totalDiscountAmount;
        }
    }

    /**
        * get total quantity from orderline items
        * @returns number
        */
    getTotalQuantity(orderLineItems: any): number {
        let totalQty = 0;
        if (orderLineItems && orderLineItems.length) {
            orderLineItems.forEach(item => {
                if (!item.depositFeeProduct) {
                    totalQty = totalQty + item.quantity;
                }
            });
        }
        return totalQty;
    }

    getShipMethodInfo(orderDetails: any) {
        if (orderDetails && orderDetails.orderShippings.length > 0
            && orderDetails.orderShippings[0].shipMethodId && orderDetails.storeId) {
            this.shipFrom = orderDetails.orderShippings[0].distributionCenter;
            this.shippingMethod = orderDetails.orderShippings[0].shippingMethodDisplayName;
            this.shippingImage = this.shippingMethod.replace(/\s/g, '');
        }
        this.orderInfoObj.shipFrom = this.shipFrom;
        this.orderInfoObj.shippingMethod = this.shippingMethod;
        this.orderInfoObj.shippingImage = this.shippingImage;
    }


    /**
      * @description  prepare MemberAddress
      * @author Akhil
      * @date 2020-11-27
      * @param {*} addresses
      * @memberof PrintLayoutComponent
      */
    getMemberAddressByMemberId(addresses: any) {

        this.shippingAddressInfo = null;
        this.memberAddressDetails = [];
        addresses.forEach((address: any) => {
            let name = '';
            if (address && address.firstName && address.lastName) {
                const middleName = address && address.middleName &&  this.orderStoreInfo && this.orderStoreInfo.displayMiddleName ? address.middleName : '';
                name = address.firstName + ' ' + (middleName ? middleName + ' ' : '') + address.lastName;
            } else if (this.shippingAddressInfo && address.shipToName || address.name) {
                name = address.shipToName || address.name;
            }
            this.memberAddressDetails.push({
                id: address.id,
                shipToName: name || address.name || '',
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                addressLine3: address.addressLine3,
                addressLine4: address.addressLine4,
                addressType: address.addressType,
                city: address.city,
                stateId: address.stateId,
                countryId: address.countryId,
                state: address.state,
                stateCode: address.stateCode,
                country: address.country,
                countryCode: address.countryCode,
                postalCode: address.postalCode,
                addressVerified: address.addressVerified,
                phone: address.phone,
                email: address.email,
                firstName: address.firstName,
                lastName: address.lastName,
                middleName: address.middleName,
                displayMiddleName: this.orderStoreInfo ? this.orderStoreInfo.displayMiddleName : false
            });
        });
        if (this.memberAddressDetails.length > 0) {
            const shippingInfo = this.memberAddressDetails.find((address: any) =>
                (address.addressType === AddressType.SHIPPING) || (address.addressType === AddressType.PICKUP)
                || (address.addressType === AddressType.PICKUP_PERSON)|| (address.addressType === AddressType.DROPSHIP));
            this.shippingAddressInfo = shippingInfo;
            this.shippingCountry = this.shippingAddressInfo.country;
        }
        this.orderInfoObj.shippingAddressInfo = this.shippingAddressInfo;
        this.orderInfoObj.shippingCountry = this.shippingCountry;
        this.orderInfoObj.memberAddressDetails = this.memberAddressDetails;
    }
    
    /**
 * get Participating countries
 * @param countryCode
 */
    private getParticipatingCountries(countryCode: string, orderDetails,distributorInfo): void {
        if (this.countries) {
            this.participatingCountries = this.countries;
            if (this.appCountryConfig.enableVATCalculation) {
                this.orderDetailsConfig.displayVat = distributorInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR ? true : false;
            }
            if(this.vatBreakdownCountry){
                this.orderDetailsConfig.displayVat = true;
            }
            this.displayOrderVatTax(orderDetails);
        }

    }

    /**
      * @description display order vat tax based on order type id and country taxinclusive
      * @memberof OrderDetailsComponent
      */
    displayOrderVatTax(orderDetails): void {
        if (this.appCountryConfig.enableVATCalculation && this.orderDetailsConfig.displayVat && orderDetails) {
            if (orderDetails.orderTypeId === PurchaseFlow.Enrollment && orderDetails.initialOrder
                && orderDetails.vatRegistered) {
                this.orderDetailsConfig.displayVat = true;
            } else if (this.shippingAddressInfo && this.shippingAddressInfo.countryId && this.participatingCountries
                && this.participatingCountries.length && orderDetails.vatRegistered) {
                const country = this.participatingCountries
                    .find(x => x.countryId === this.shippingAddressInfo.countryId);
                this.orderDetailsConfig.displayVat = this.getCountryTaxInclusiveInfo(country);
            } else {
                this.orderDetailsConfig.displayVat = false;
            }
        } else if (!orderDetails.vatRegistered && !this.appCountryConfig.enableVATCalculation) {
            this.orderDetailsConfig.displayVat = false;
        }
        if(this.vatBreakdownCountry){
            this.orderDetailsConfig.displayVat = true;
        }
    }


    /**
        * @description to get taxinclusive info
        * @memberof OrderDetailsComponent
        */
    getCountryTaxInclusiveInfo(country: any): boolean {
        let countryTaxInclusive = false;
        if (country && country.countryMetadata &&
            country.countryMetadata.length > 0 &&
            country.countryMetadata[0].metadata) {
            countryTaxInclusive = (country.countryMetadata[0].metadata[0].value === 'TRUE') ? true : false;
        }
        return countryTaxInclusive;
    }

    /**
         * @description getregistered Address
         * @author Akhil
         * @date 2020-11-30
         * @memberof PrintLayoutComponent
         */
    getMemberDetailById(memberAddressInfo): void {
        if (memberAddressInfo) {
            this.registerAddress = memberAddressInfo.address;
            this.registerAddress.firstName = this.registerAddress.firstName ? this.registerAddress.firstName
                : memberAddressInfo.firstName ? memberAddressInfo.firstName : null;
            if (this.orderStoreInfo && this.orderStoreInfo.displayMiddleName) {
                this.registerAddress.middleName = this.registerAddress.middleName ? this.registerAddress.middleName
                    : memberAddressInfo.middleName ? memberAddressInfo.middleName : null;
            }
            this.registerAddress.lastName = this.registerAddress.lastName ? this.registerAddress.lastName
                : memberAddressInfo.lastName ? memberAddressInfo.lastName : null;
            this.registerAddress.phoneNumber = this.registerAddress.phoneNumber ? this.registerAddress.phoneNumber
                : memberAddressInfo.phone ? memberAddressInfo.phone : null;
            this.registerAddress.email = this.registerAddress.email ? this.registerAddress.email
                : memberAddressInfo.email ? memberAddressInfo.email : null;
            this.registerAddressphoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(this.registerAddress.countryCode);
        }
        this.orderInfoObj.registerAddress = this.registerAddress;
        this.orderInfoObj.registerAddressphoneNumberFormat = this.registerAddressphoneNumberFormat;
    }

    /**
         * setDefaultShippingPic Method used to display default text for Shipping method
         * @returns void
         */
    setDefaultShippingPic(): void {
        this.shippingImageFlag = false;
    }


    /**
 *
 * @param items
 */
    getItemVolumeSum(items, i): number {
        if (this.appCountryConfig.roundoffTaxAmount) {
            return Math.round(items
                .map(function (x) { return x.taxAmount; })
                .reduce(function (a, b) { return a + b; }));
        } else {
            return items
                .map(function (x) { return x.taxAmount; })
                .reduce(function (a, b) { return a + b; });
        }
    }

    getItemTaxChargeBasedSum(items): number {
        return items
          .map(function (x) { return x.taxChargeBased; })
          .reduce(function (a, b) { return a + b; });
      }

    /**
     *
     * @param storeId
     */
    private getStoreMetaData(storeMetaInfo): void {
        if (storeMetaInfo && storeMetaInfo.length > 0) {
            // const corporateVatAttribute = storeMetaInfo.find(x => (x.attribute &&
            //     x.attribute.toLowerCase() === StoreMetaDataConstants.CORPORATE_VAT_ID.toLowerCase()));
            // if (corporateVatAttribute && corporateVatAttribute.metaDataValue) {
            //     this.corporateVatId = corporateVatAttribute.metaDataValue;
            // }
            storeMetaInfo.forEach((metaData) => {
                if (metaData && metaData.metaDataValue && metaData.attribute) {
                  if (metaData.attribute.toLowerCase() === StoreMetaDataConstants.CORPORATE_VAT_ID.toLowerCase()) {
                    this.corporateVatId = metaData.metaDataValue;
                  }
                  if (metaData.attribute.toLowerCase() === StoreMetaDataConstants.ORGANIZATION_NUMBER.toLowerCase()) {
                    this.organizationNumber = metaData.metaDataValue;
                  }
                  if (metaData.attribute.toLowerCase() === StoreMetaDataConstants.TAX_CERTIFICATE_NOTE.toLowerCase()) {
                    this.taxCertificateNote = metaData.metaDataValue;
                  }
                  if (metaData.attribute.toLowerCase() === StoreMetaDataConstants.PLACE_OF_INCORPORATION.toLowerCase()) {
                    this.placeOfIncorporation = metaData.metaDataValue;
                  } if (metaData.attribute.toLowerCase() === StoreMetaDataConstants.CREDITOR_ID.toLowerCase()) {
                    this.creditorID = metaData.metaDataValue;
                  }
                }
              });

        }
    }

    /**
     * Vat number
     */
    private getStoresInfo(): void {

        if (this.orderStoreInfo) {
            this.vatNumber = this.orderStoreInfo.vatNumber;
            this.enableVatinInvoice = this.orderStoreInfo.enableVatInInvoice;
            this.storeTimeZoneOffSet = this.orderStoreInfo.timeZoneOffset;
        }
    }

    getFlpLogo() {
        return environment.uiTemplateBaseUrl + '/images/flpi-logo.jpg';
    }
    
    isVatBreakdownCountry(isoCountryCode: string): boolean {
        return this.vatBreakdownStores.find((country) => country === isoCountryCode.toUpperCase()) ? true : false;
    }
    
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/reports/print-invoice.component.ts